module.exports = __webpack_public_path__ + "static/media/RizwanTanoli.11c5631f.jpeg";